module.exports = __webpack_public_path__ + "static/media/chat_bubble_small.671f0bde.svg";